import comp from './NotFound';
export default comp;
